export default __webpack_public_path__ + "static/media/lock-icon.fddaa827.svg";